import * as t from './types'

export const setAccessToken = (payload: string): t.ApplicationStateActionTypes => {
  return { type: t.SET_ACCESS_TOKEN, payload }
}